import {Box, type BoxProps} from '@mantine/core';
import {tablerIconUrl} from '../../utils/tablerIconKey';

type TablerIconImageProps = {
    icon: string;
    size?: number;
} & Pick<BoxProps, 'style'>;

export function TablerIconImage({icon, size = 24, style}: TablerIconImageProps) {
    const url = tablerIconUrl(icon);

    return (
        <Box
            aria-hidden
            w={size}
            h={size}
            className="tabler-icon-img"
            style={{
                WebkitMaskImage: `url(${url})`,
                maskImage: `url(${url})`,
                ...style,
            }}
        />
    );
}
